import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

const AutoUpdateModal = ({ show, onHide, onConfirm, loading = false }) => {
    const [logMessage, setLogMessage] = useState('');

    const handleConfirm = async () => {
        try {
            await onConfirm(logMessage.trim());
            setLogMessage(''); // Limpar após confirmar
            onHide();
        } catch (error) {
            console.error('Error in auto update:', error);
        }
    };

    const handleClose = () => {
        setLogMessage(''); // Limpar ao fechar
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="md" centered>
            {/* Header with alert icon */}
            <Modal.Header className='bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 flex items-center' style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                marginBottom: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <span style={{ fontWeight: 'bold' }}>Alerta</span>
                <FaExclamationTriangle />
            </Modal.Header>

            <Modal.Body style={{ padding: '30px', textAlign: 'center' }}>
                {/* Alert message */}
                <div style={{ marginBottom: '25px', lineHeight: '1.6' }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
                        O banco de dados analisado será atualizado a partir das informações presentes atualmente no <span style={{ color: '#007bff', fontWeight: 'bold' }}>AIDA</span>. <br />
                        Essa operação pode levar algum tempo para ser concluída. <br /> <br />
                        <strong>Confirmar operação?</strong>
                    </p>
                </div>

                {/* Log message input */}
                <div style={{ marginBottom: '25px', textAlign: 'left' }}>
                    <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'center'
                    }}>
                        Mensagem de log (opcional)
                    </label>
                    <Form.Control
                        type="text"
                        value={logMessage}
                        onChange={(e) => setLogMessage(e.target.value)}
                        placeholder="Digite uma mensagem para registrar no log..."
                        disabled={loading}
                        style={{
                            borderRadius: '8px',
                            padding: '12px',
                            fontSize: '14px'
                        }}
                    />
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                    <Button
                        variant="danger"
                        onClick={handleClose}
                        disabled={loading}
                        style={{
                            backgroundColor: '#dc3545',
                            borderColor: '#dc3545',
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '100px'
                        }}
                    >
                        Voltar
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleConfirm}
                        disabled={loading}
                        style={{
                            backgroundColor: '#003B6B',
                            borderColor: '#003B6B',
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '100px'
                        }}
                    >
                        {loading ? 'Processando...' : 'Confirmar'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AutoUpdateModal;